export default "__VITE_ASSET__C_8V29E2__"